import React from 'react';
import PropTypes from 'prop-types';
import ConnectedRegisterForm from './ConnectedRegisterForm';

// TODO: Move to react-viewerbase

function RegisterRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedRegisterForm />;
}

RegisterRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default RegisterRouting;
